import React, { useState, useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { useAuth } from '../../../context/auth';
import './MobileMenu.css';

const MobileMenu = () => {
  const [isOpen, setIsOpen] = useState(false);
  const { currentUser, logout } = useAuth();
  const location = useLocation();

  // Close menu when route changes
  useEffect(() => {
    setIsOpen(false);
  }, [location.pathname]);

  // Close menu when clicking outside
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (isOpen && !event.target.closest('.mobile-menu')) {
        setIsOpen(false);
      }
    };

    if (isOpen) {
      document.addEventListener('mousedown', handleClickOutside);
      document.body.style.overflow = 'hidden'; // Prevent background scroll
    }

    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
      document.body.style.overflow = 'unset';
    };
  }, [isOpen]);

  const handleLogout = async () => {
    try {
      await logout();
      setIsOpen(false);
    } catch (error) {
      console.error('Failed to log out:', error);
    }
  };

  const toggleMenu = () => {
    setIsOpen(!isOpen);
  };

  return (
    <div className="mobile-menu">
      {/* Menu Button */}
      <button
        className={`menu-button ${isOpen ? 'close' : 'hamburger'}`}
        onClick={toggleMenu}
        aria-label={isOpen ? 'Close menu' : 'Open menu'}
        aria-expanded={isOpen}
      >
        {isOpen ? (
          <span className="close-icon">×</span>
        ) : (
          <>
            <span className="hamburger-line"></span>
            <span className="hamburger-line"></span>
            <span className="hamburger-line"></span>
          </>
        )}
      </button>

      {/* Mobile Menu Overlay */}
      <div className={`mobile-menu-overlay ${isOpen ? 'active' : ''}`}>
        <div className="mobile-menu-content">
          {/* Logo */}
          <div className="mobile-menu-header">
            <Link to="/" onClick={() => setIsOpen(false)}>
              <img src="/lp-icon.png" alt="Literally Possible Logo" className="mobile-logo" />
            </Link>
          </div>

          {/* Navigation Links */}
          <nav className="mobile-nav">
            <div className="mobile-nav-section">
              <Link to="/" onClick={() => setIsOpen(false)} className="mobile-nav-link">
                Home
              </Link>
              <a href="#services" onClick={() => setIsOpen(false)} className="mobile-nav-link">
                Services
              </a>
              <a href="#about" onClick={() => setIsOpen(false)} className="mobile-nav-link">
                About
              </a>
              <a href="#contact" onClick={() => setIsOpen(false)} className="mobile-nav-link">
                Contact
              </a>
            </div>

            {/* Authentication Section */}
            <div className="mobile-nav-section">
              <h3>Account</h3>
              {currentUser ? (
                <>
                  <Link to="/dashboard" onClick={() => setIsOpen(false)} className="mobile-nav-link">
                    Dashboard
                  </Link>
                  <button onClick={handleLogout} className="mobile-nav-button">
                    Sign Out
                  </button>
                </>
              ) : (
                <>
                  <Link to="/login" onClick={() => setIsOpen(false)} className="mobile-nav-link">
                    Sign In
                  </Link>
                  <Link to="/signup" onClick={() => setIsOpen(false)} className="mobile-nav-button">
                    Sign Up
                  </Link>
                </>
              )}
            </div>
          </nav>

          {/* Footer */}
          <div className="mobile-menu-footer">
            <p>&copy; 2025 Literally Possible, LLC.</p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default MobileMenu; 